import { useContext, useEffect, useState } from "react";
import { Context } from ".";
import { BrowserRouter } from "react-router-dom";
import { observer } from "mobx-react-lite";
import AppRouter from "./components/AppRouter";
import SideMenu from "./components/SideMenu";
import Auth from "./pages/Auth";
import Rates from "./pages/Rates";
import NotificationContainer from "./components/NotificationContainer";
import useNotification from "./hooks/useNotification";
import NotificationProvider from "./components/NotificationProvider";

function App() {
    const { store } = useContext(Context);
    const [isLoaderVisible, setIsLoaderVisible] = useState(true);

    useEffect(() => {
        if (localStorage.getItem('token')) {
            store.checkAuth();
        }
    }, [])

    useEffect(() => {
        if (!store.isLoading) {
            // Запускаем исчезновение лоадера
            setIsLoaderVisible(false);
        }
    }, [store.isLoading]);

    if (store.isLoading || isLoaderVisible) return <div className="loading"></div>
    if (!store.isAuth && !store.isLoading) {
        return <Auth/>
    }
    if (store.userInfo && store.userInfo.hasAccess == false && window.location.pathname != "/profile" && window.location.pathname != "/rates") {
        window.location.replace("/rates");
        return;
    }

    return (
        <BrowserRouter>
            <div className={`loading ${!store.isLoading && store.userInfo.hasAccess != undefined ? "fade-out" : ""}`}><span className="loader"></span></div>
            {store.isAuth
                ? <SideMenu><AppRouter/></SideMenu>
                : <AppRouter/>
            }
        </BrowserRouter>
    );
}

export default observer(App);
